enum AllowSignatureType {
  SIGN = 'SIGN',
  STAMP = 'STAMP',
}

export default AllowSignatureType;
